import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = (n: any) => (_pushScopeId("data-v-29e50992"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "item-name-text" }

import { computed, ref } from 'vue'
import RankingChart, { RankingItem } from '@/views/dashboard/_components/ranking-chart/ranking-chart.vue'
import { ActiveStartupTerminalTop5 } from '../service';



export default /*#__PURE__*/_defineComponent({
  __name: 'active-terminal-ranking-chart',
  props: {
    data: { default: () => [] }
  },
  emits: ["itemClick"],
  setup(__props: any, { expose: __expose, emit: __emit }) {

const props = __props

const emit = __emit

function onRankingItemClick(item: RankingItem) {
  emit('itemClick', item)
}

function startupItemDisplayName(item: Record<string, unknown>) {
  return String(item.name ?? '')
}

const loading = ref(false)

const chartData = computed(() => {
  return props.data.map(item => ({
    name: item.startup_item_name,
    count: item.startup_item_count || 0,
  }))
})

__expose({
  loading
})

return (_ctx: any,_cache: any) => {
  const _component_el_tag = _resolveComponent("el-tag")!

  return (_openBlock(), _createBlock(RankingChart, {
    title: _ctx.$t('bootOptimize.activeTerminalRankingTitle'),
    data: chartData.value,
    "show-time-range": false,
    unit: _ctx.$t('common.unitItems'),
    "name-key": "name",
    "max-items": 5,
    "card-size": 'second',
    loading: loading.value,
    "onUpdate:loading": _cache[0] || (_cache[0] = ($event: any) => ((loading).value = $event)),
    "row-clickable": "",
    onItemClick: onRankingItemClick
  }, {
    "item-name": _withCtx(({ item }) => [
      _createElementVNode("span", _hoisted_1, _toDisplayString(startupItemDisplayName(item)), 1)
    ]),
    titleAfter: _withCtx(() => [
      _createVNode(_component_el_tag, {
        size: "small",
        type: "primary"
      }, {
        default: _withCtx(() => [
          _createTextVNode(_toDisplayString(_ctx.$t('common.rankTagTop5')), 1)
        ]),
        _: 1
      })
    ]),
    _: 1
  }, 8, ["title", "data", "unit", "loading"]))
}
}

})